import styles from "./PlanItemModal.module.scss"
import "./PlanItemModal.scss"
import {IPackage, IPackageOption, IPricesModel, IRequestForGetPackagePrice} from "../../../models/Package";
import React, {useEffect, useState} from "react";
import closePopupIcon from "../../../assets/images/icons/close-pupup-dark.svg";
import {useTranslation} from "react-i18next";
import CustomButton from "../../UI/CustomButton/CustomButton";
import CouponForm from "../../CouponForm/CouponForm";
import {ICoupon, ICouponError} from "../../../models/Coupon";
import useAppSelector from "../../../hooks/useAppSelector";
import {Switch} from "antd";
import PaymentMethodsPopup from "../../PaymentMethodsPopup/PaymentMethodsPopup";
import StripeElements from "../../StripeElements/StripeElements";
import {PurchaseTypes} from "../../../models/Payment";
import {PlansService} from "../../../services/plans.service";
import useAppDispatch from "../../../hooks/useAppDispatch";
import {openMessage} from "../../../store/notification/notificationSlice";
import LoyaltyPointsExchanges from "../../LoyaltyPointsExchanges/LoyaltyPointsExchanges";

interface IPlanItemModal {
    item: IPackage;
    setIsModalOpen: (value: boolean) => void;
}

const PlanItemModal: React.FC<IPlanItemModal> = ({item, setIsModalOpen}) => {

    const {t} = useTranslation();
    const dispatch = useAppDispatch();
    const profile = useAppSelector(state => state.profileSlice.profile);
    const [currentPlanOption, setCurrentPlanOption] = useState<IPackageOption | null>(null);
    const [coupon, setCoupon] = useState<ICoupon | ICouponError | {}>({});
    const [loyaltyExchangeId, setLoyaltyExchangeId] = useState<number | null>(null);
    const {gymSettings} = useAppSelector(state => state.gymSettingsSlice);
    const {gateway} = useAppSelector(state => state.stripeKeysSlice);
    const [autoRenewal, setAutoRenewal] = useState(false);
    const [packageOptionPrices, setPackageOptionPrices] = useState<IPricesModel | null>(null);
    const [showPaymentMethodPopup, setShowPaymentMethodPopup] = useState<{
        visible: boolean,
        orderParams: any
    }>({visible: false, orderParams: null});

    const handleSetCurrentPlanOption = async (planOption: IPackageOption) => {
        if (!planOption) return;
        await getPackageOptionPrice(planOption.id);
        setCurrentPlanOption(planOption);
        setAutoRenewal(planOption.forceAutoRenewal);
    }

    useEffect(() => {
        if (currentPlanOption) {
            getPackageOptionPrice(currentPlanOption.id)
        }
    }, [coupon, loyaltyExchangeId]);

    const getPackageOptionPrice = async (packageOptionId: number) => {
        if (!profile) return;
        try {
            let couponCode = null;
            if ("couponCode" in coupon && coupon.couponCode) {
                couponCode = coupon.couponCode;
            }
            const model: IRequestForGetPackagePrice = {
                customerId: profile.customerId,
                packageOptionId,
                couponCode,
                loyaltyExchangeId
            }
            const response = await PlansService.getPackagePrice(model);
            if (response.data.error) {
                dispatch(openMessage({type: "error", title: t(response.data.error.message)}));
                return;
            }
            if (response.status) {
                setPackageOptionPrices(response.data.data.prices);
            } else {
                dispatch(openMessage({type: "error", title: t("FailedToCalculatePackagePrice")}));
            }
        } catch (e) {
            dispatch(openMessage({type: "error", title: t("FailedToCalculatePackagePrice")}));
        }
    }

    const clickToPayButton = () => {

        const orderParams = {
            cartItems: [
                {
                    packageOptionId: currentPlanOption?.id,
                    autoRenewalEnabled: autoRenewal,
                }
            ],
            couponCode: "couponCode" in coupon ? coupon.couponCode : null,
            customerId: gateway.customerId,
            api_version: "2022-11-15",
            returnUrl: `${window.location.protocol}//${window.location.hostname}/account/subscriptions`,
            loyaltyExchangeId
        }

        setShowPaymentMethodPopup({visible: true, orderParams});
    }

    const onChangeSwitch = (checked: boolean) => {
        setAutoRenewal(checked);
    }

    const hidePaymentsPopup = () => {
        setShowPaymentMethodPopup({visible: false, orderParams: null})
    }

    return (
        <>
            <div className={styles.container}>
                <div className={styles.modal}>

                    <div className={styles.scrollWrapper}>

                        <div className={styles.closeWrapper}>
                            <img
                                onClick={() => setIsModalOpen(false)}
                                src={closePopupIcon}
                                alt={"close"}
                            />
                        </div>

                        <div className={styles.classesWrapper}>
                            <ul className={`${styles.list} ${styles.main}`}>
                                <li className={`${styles.item} ${styles.name}`}>{t("Name")}</li>
                                <li className={`${styles.item} ${styles.sessions}`}>{t("Sessions")}</li>
                                <li className={`${styles.item} ${styles.duration}`}>{t("Duration")}</li>
                                <li className={`${styles.item} ${styles.price}`}>{t("Price")}</li>
                            </ul>
                            {
                                item.options.length !== 0 &&
                                item.options.map((el, index) => {
                                    return (
                                        <ul
                                            key={el.id}
                                            className={`${styles.list} ${!(index % 2) && styles.gray} ${el.id === currentPlanOption?.id && styles.active}`}
                                            onClick={() => handleSetCurrentPlanOption(el)}
                                        >
                                            <li className={`${styles.item} ${styles.name}`}>{el.name}</li>
                                            <li className={`${styles.item} ${styles.sessions}`}>{el.credits === 999999999 ? "Unlimited" : el.credits}</li>
                                            <li className={`${styles.item} ${styles.duration}`}>{el.duration}</li>
                                            <li className={`${styles.item} ${styles.price}`}>{el.price}</li>
                                        </ul>
                                    )
                                })
                            }
                        </div>

                        <div className={styles.description}>
                            <p className={styles.label}>{t("Description")}</p>
                            <p className={styles.text}>{item.description}</p>
                        </div>

                        {
                            currentPlanOption && currentPlanOption.autoRenewalAllowed && (
                                <div className="modal-switch">
                                    <Switch
                                        id={"switch"}
                                        className={"switch"}
                                        disabled={currentPlanOption.forceAutoRenewal}
                                        value={autoRenewal}
                                        onChange={onChangeSwitch}
                                    />
                                    <label className={`${currentPlanOption.forceAutoRenewal && "disabled"}`}
                                           htmlFor={"switch"}>Auto
                                        Renewal</label>
                                    <div className={"more"}>
                                        <svg className={"icon"} width="24" height="24" viewBox="0 0 24 24"
                                             fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM11.99 10C12.548 10 13 10.452 13 11.01V16.134C13.1906 16.2441 13.3396 16.414 13.4238 16.6173C13.5081 16.8207 13.5229 17.0462 13.4659 17.2588C13.4089 17.4714 13.2834 17.6593 13.1087 17.7933C12.9341 17.9273 12.7201 18 12.5 18H12.01C11.8774 18 11.746 17.9739 11.6235 17.9231C11.501 17.8724 11.3896 17.798 11.2958 17.7042C11.202 17.6104 11.1276 17.499 11.0769 17.3765C11.0261 17.254 11 17.1226 11 16.99V12C10.7348 12 10.4804 11.8946 10.2929 11.7071C10.1054 11.5196 10 11.2652 10 11C10 10.7348 10.1054 10.4804 10.2929 10.2929C10.4804 10.1054 10.7348 10 11 10H11.99ZM12 7C12.2652 7 12.5196 7.10536 12.7071 7.29289C12.8946 7.48043 13 7.73478 13 8C13 8.26522 12.8946 8.51957 12.7071 8.70711C12.5196 8.89464 12.2652 9 12 9C11.7348 9 11.4804 8.89464 11.2929 8.70711C11.1054 8.51957 11 8.26522 11 8C11 7.73478 11.1054 7.48043 11.2929 7.29289C11.4804 7.10536 11.7348 7 12 7Z"
                                                fill="#5E5E5E"/>
                                        </svg>
                                        <div
                                            className={"description"}>{t("TheSubscriptionWillAutomaticallyRenewsAtTheEndOfEachBillingPeriod")}</div>
                                    </div>


                                </div>
                            )
                        }
                        <div className={styles.coupon}>
                            <CouponForm
                                coupon={coupon}
                                setCoupon={setCoupon}
                                scope={"subscription"}
                            />
                        </div>

                        {
                            gymSettings?.enableLoyaltyPoints && (
                                <div className={styles.loyalty}>
                                    <LoyaltyPointsExchanges
                                        itemPrice={currentPlanOption ? Number(currentPlanOption.price) : null}
                                        setActiveLoyaltyExchangeId={setLoyaltyExchangeId}
                                        activeLoyaltyExchangeId={loyaltyExchangeId}
                                    />
                                </div>

                            )
                        }

                        <div className={styles.transaction}>
                            <div className={styles.fees}>
                                <div>
                                    <p className={styles.label}>{t("TransactionFees")}:</p>
                                    <p className={styles.price}>{packageOptionPrices && packageOptionPrices.fees !== 0 ? packageOptionPrices.fees.toFixed(2) : "0.00"}</p>
                                </div>
                                <p className={styles.text}>* {t("TransactionFeesDescription")}</p>
                            </div>
                            <div className={styles.total}>
                                <p className={styles.label}>{t("Total")}</p>
                                <p className={styles.price}>{packageOptionPrices ? packageOptionPrices.total.toFixed(2) : "0.00"}</p>
                            </div>
                        </div>

                        <div className={styles.btnWrapper}>
                            <CustomButton
                                text={t("Pay") + ` ${gymSettings?.defaultCurrencyCode} ${packageOptionPrices ? packageOptionPrices.total.toFixed(2) : '0.00'}`}
                                type={"button"}
                                typeStyle={"fill"}
                                borderRadius={false}
                                functionOnClick={clickToPayButton}
                                disabled={!currentPlanOption}
                            />
                        </div>
                    </div>


                </div>
            </div>
            {
                showPaymentMethodPopup.visible && (
                    <StripeElements>
                        <PaymentMethodsPopup
                            closePopupFn={hidePaymentsPopup}
                            functionOnContinue={() => {
                                hidePaymentsPopup()
                                setIsModalOpen(false)
                            }}
                            purchasingType={PurchaseTypes.Subscription}
                            orderParams={showPaymentMethodPopup.orderParams}
                        />
                    </StripeElements>

                )
            }
        </>

    )
}

export default PlanItemModal;